import Vue from 'vue';
import VueRouter from 'vue-router';
import meta from '@/api/meta';
import store from '@/config/store';
import axios from 'axios';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/main',
            component: () => import('@/layouts/Top.vue'),
            children: [
                {
                    path: '/main',
                    component: () => import('@/pages/main/main.vue'),
                },
                {
                    path: '/tutoring-application',
                    component: () => import('@/pages/tutoring-application/main.vue'),
                },
                {
                    path: '/tutoring-application/detail',
                    component: () => import('@/pages/tutoring-application/detail/main.vue'),
                },
                {
                    path: '/tutoring-application/result',
                    component: () => import('@/pages/tutoring-application/result/main.vue'),
                },
                {
                    path: '/sign-in',
                    component: () => import('@/pages/sign-in/main.vue'),
                },
                {
                    path: '/user-div',
                    component: () => import('@/pages/sign-up/user-div/main.vue'),
                },
                {
                    path: '/sign-up',
                    component: () => import('@/pages/sign-up/main.vue'),
                },
                {
                    path: '/findid',
                    component: () => import('@/pages/findId/main.vue'),
                },
                {
                    path: '/findpw',
                    component: () => import('@/pages/findPw/main.vue'),
                },
                {
                    path: '/teacher-auth',
                    component: () => import('@/pages/teacher-auth/main.vue'),
                },
                {
                    path: '/teacher-auth-agreement',
                    component: () => import('@/pages/teacher-auth/agreement/main.vue'),
                },
                {
                    path: '/mypage/teachers',
                    redirect: '/mypage/teachers/profile',
                },
                {
                    path: '/mypage/teachers/profile',
                    component: () => import('@/pages/mypage/teachers/profile/main.vue'),
                },
                {
                    path: '/mypage/teachers/students',
                    component: () => import('@/pages/mypage/teachers/student/main.vue'),
                },
                {
                    path: '/mypage/teachers/students/detail',
                    component: () => import('@/pages/mypage/teachers/student/detail/main.vue'),
                },
                {
                    path: '/mypage/teachers/students/detail/curriculum',
                    component: () => import('@/pages/mypage/teachers/student/detail/curriculum/main.vue'),
                },
                {
                    path: '/mypage/teachers/class',
                    component: () => import('@/pages/mypage/teachers/class/main.vue'),
                },
                {
                    path: '/teacher-auth',
                    component: () => import('@/pages/teacher-auth/main.vue'),
                },
                {
                    path: '/communities',
                    component: () => import('@/pages/community/main.vue'),
                },
                {
                    path: '/communities/detail',
                    component: () => import('@/pages/community/main-detail.vue'),
                },
                {
                    path: '/communities/registration',
                    component: () => import('@/pages/community/registration/main.vue'),
                },
                {
                    path: '/mypage/students',
                    redirect: '/mypage/students/profile',
                },
                {
                    path: '/mypage/students/profile',
                    component: () => import('@/pages/mypage/students/profile/main.vue'),
                },
                {
                    path: '/mypage/students/evaluation',
                    component: () => import('@/pages/mypage/students/evaluation/main.vue'),
                },
                {
                    path: '/mypage/students/evaluation/detail',
                    component: () => import('@/pages/mypage/students/evaluation/detail/main.vue'),
                },
                {
                    path: '/mypage/students/class',
                    component: () => import('@/pages/mypage/students/class/main.vue'),
                },
                {
                    path: '/mypage/students/password',
                    component: () => import('@/pages/mypage/students/password/main.vue'),
                },
                {
                    path: '/mypage/students/d-day',
                    component: () => import('@/pages/mypage/students/d-day/main.vue'),
                },
                {
                    path: '/mypage/students/curriculum',
                    component: () => import('@/pages/mypage/students/curriculum/main.vue'),
                },
                {
                    path: '/mypage/students/teachers/detail',
                    component: () => import('@/pages/mypage/students/curriculum/detail.vue'),
                },
                {
                    path: '/mypage/students/reservation',
                    component: () => import('@/pages/mypage/students/reservation/main.vue'),
                },
                {
                    path: '/mypage/teachers/password',
                    component: () => import('@/pages/mypage/teachers/password/main.vue'),
                },
                {
                    path: '/mypage/teachers/reservation',
                    component: () => import('@/pages/mypage/teachers/reservation/main.vue'),
                },
                {
                    path: '/mypage/teachers/evaluation',
                    component: () => import('@/pages/mypage/teachers/evaluation/main.vue'),
                },
                {
                    path: '/mypage/teachers/evaluation/detail',
                    component: () => import('@/pages/mypage/teachers/evaluation/detail/main.vue'),
                },
                {
                    path: '/faqs',
                    component: () => import('@/pages/faq/main.vue'),
                },
                {
                    path: '/students/main',
                    component: () => import('@/pages/student/main.vue'),
                },
                {
                    path: '/students/main/chat',
                    component: () => import('@/pages/student/pageChat.vue'),
                },
                {
                    path: '/students/main/homework',
                    component: () => import('@/pages/student/homework.vue'),
                },
                {
                    path: '/students/main/homework/detail',
                    component: () => import('@/pages/student/homeworkDetail.vue'),
                },
                {
                    path: '/students/main/homework/view',
                    component: () => import('@/pages/student/homeworkView.vue'),
                },
                {
                    path: '/students/main/recod',
                    component: () => import('@/pages/student/recod.vue'),
                },
                {
                    path: '/teachers/main',
                    component: () => import('@/pages/teacher/main.vue'),
                },
                {
                    path: '/teachers/main/chat',
                    component: () => import('@/pages/teacher/pageChat.vue'),
                },
                {
                    path: '/teachers/main/homework',
                    component: () => import('@/pages/teacher/homework.vue'),
                },
                {
                    path: '/teachers/main/homework/detail',
                    component: () => import('@/pages/teacher/homework_detail.vue'),
                },
                {
                    path: '/privacy',
                    component: () => import('@/pages/main/privacy/main.vue'),
                },
                {
                    path: '/policy',
                    component: () => import('@/pages/main/policy/main.vue'),
                },
            ],
        },
        {
            path: '/sign-in',
            redirect: '/sign-in',
            component: () => import('@/layouts/Blank.vue'),
            children: [
                {
                    path: '/sign-in/naver',
                    component: () => import('@/pages/sign-in/naver/main.vue'),
                },
                // {
                //     path: '*',
                //     component: () => import('@/pages/exception/main.vue'),
                // },
                {
                    path: '/pop-up',
                    component: () => import('@/pages/main/popUp/main.vue'),
                },
            ],
        },
        {
            path: '/settings',
            redirect: '/settings/apis',
            component: () => import('@/layouts/Admin.vue'),
            children: [
                {
                    path: '/settings/apis',
                    component: () => import('@/pages/setting/api/main.vue'),
                },
                {
                    path: '/settings/apis/detail',
                    component: () => import('@/pages/setting/api/main-detail.vue'),
                },
                {
                    path: '/settings/menus',
                    component: () => import('@/pages/setting/menu/main.vue'),
                },
                {
                    path: '/settings/menus',
                    component: () => import('@/pages/setting/menu/main.vue'),
                },
                {
                    path: '/settings/roles',
                    component: () => import('@/pages/setting/role/main.vue'),
                },
                {
                    path: '/settings/roles/detail',
                    component: () => import('@/pages/setting/role/main-detail.vue'),
                },
                {
                    path: '/settings/users',
                    component: () => import('@/pages/setting/user/main.vue'),
                },
                {
                    path: '/settings/codes',
                    component: () => import('@/pages/setting/code/main.vue'),
                },
                {
                    path: '/settings/notice',
                    component: () => import('@/pages/setting/notice/main.vue'),
                },
                {
                    path: '/settings/notice/detail',
                    component: () => import('@/pages/setting/notice/main-detail.vue'),
                },
                {
                    path: '/settings/community',
                    component: () => import('@/pages/setting/community/main.vue'),
                },
                {
                    path: '/settings/community/detail',
                    component: () => import('@/pages/setting/community/main-detail.vue'),
                },
                {
                    path: '/settings/tutoring-application',
                    component: () => import('@/pages/setting/tutoring-application/main.vue'),
                },
                {
                    path: '/settings/teacher-auth',
                    component: () => import('@/pages/setting/teacher-auth/main.vue'),
                },
                {
                    path: '/settings/teacher-list',
                    component: () => import('@/pages/setting/teacher-list/main.vue'),
                },
                {
                    path: '/settings/faqs',
                    component: () => import('@/pages/setting/faq/main.vue'),
                },
                {
                    path: '/settings/faqs/detail',
                    component: () => import('@/pages/setting/faq/faq-detail.vue'),
                },
                {
                    path: '/settings/consulting',
                    component: () => import('@/pages/setting/consulting/main.vue'),
                },
                {
                    path: '/settings/student-list',
                    component: () => import('@/pages/setting/student-list/main.vue'),
                },
            ],
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    const token = meta.auth.getToken();
    let treeMenuList;
    let treeMenu;
    const regex = to.matched.length > 0 ? to.matched[to.matched.length - 1].regex : null;
    let authenticated;
    const mainTitle = 'Study-Go';
    let subTitle = '';
    let title = '';
    let titlePath = [] as any;
    let teacherStudentShow = false;
    let i = 0;
    const storeTemp: any = store;

    if (await meta.auth.authenticated(token)) {
        if (!storeTemp.getters['app/GET_TOKEN']) {
            await meta.auth.authorize(token);
        }

        const session = (await axios({ url: `/api/common/menus/session/${storeTemp.state.app.user.id}`, method: 'get' })).data;
        store.commit('app/SET_MENU_LIST', session.menuList);
        store.commit('app/SET_TREE_MENU_LIST', session.treeMenuList);

        treeMenuList = session.treeMenuList;
        authenticated = false;
        for (i = 0; i < treeMenuList.length; i += 1) {
            treeMenu = treeMenuList[i];
            if (regex && regex.test(treeMenu.path)) {
                authenticated = true;
                break;
            }
        }
        titlePath = [];
        for (i = 0; i < treeMenuList.length; i += 1) {
            treeMenu = treeMenuList[i];
            if (new RegExp(`${treeMenu.path}.*`, 'g').test(to.path)) {
                titlePath.push(treeMenu.name);
                teacherStudentShow = treeMenu.teacherStudentShow;
            }
        }

        if (teacherStudentShow) {
            if (teacherStudentShow !== storeTemp.state.app.user.userDiv) {
                await meta.alert('접근할 수 없는 페이지입니다.');
                next('/');
            }
        }

        titlePath.splice(0, 1);
        storeTemp.commit('app/SET_SHOW_MENU_PATH_NAME', titlePath.join(' > '));
        titlePath = titlePath.reverse();
        title = titlePath.join(' < ');
        if (authenticated) {
            document.title = title;
            next();
        } else {
            next('/');
        }
    } else {
        let isLogin = false;

        meta.auth.unauthorize();
        if (to.path.startsWith('/user-div')) {
            subTitle = '회원 구분';
            titlePath = [subTitle, mainTitle];
            title = titlePath.join(' < ');
            document.title = title;
            next();
        } else if (to.path.startsWith('/sign-up')) {
            subTitle = '회원가입';
            titlePath = [subTitle, mainTitle];
            title = titlePath.join(' < ');
            document.title = title;
            next();
        } else if (to.path.startsWith('/sign-in')) {
            subTitle = '로그인';
            titlePath = [subTitle, mainTitle];
            title = titlePath.join(' < ');
            document.title = title;
            next();
        } else {
            treeMenuList = (await meta.api.util.menu.getDefaultMenuList()).data.items;

            titlePath = ['Study-GO'];
            if (to.path === '/') {
                titlePath.push('메인화면');
            }

            for (i = 0; i < treeMenuList.length; i += 1) {
                treeMenu = treeMenuList[i];
                if (treeMenu.path === to.path) {
                    if (treeMenu.publicyStatus === 'F') {
                        meta.alert('로그인이 필요합니다.');
                        isLogin = true;
                    } else {
                        titlePath.push(treeMenu.name);
                    }
                }
            }

            if (isLogin) {
                router.push({ path: '/sign-in', query: { redirectURL: to.fullPath } });
            } else if (titlePath.length === 1) {
                router.push({ path: '/' });
            } else {
                storeTemp.state.app.showMenuPathName = titlePath.join(' > ');
                titlePath = titlePath.reverse();
                title = titlePath.join(' < ');
                document.title = title;
                next();
            }
        }
    }
});

export default router;
